module.exports = __webpack_public_path__ + "static/media/banner-1.86f72847.png";